import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { authClient } from "./utils/auth.client";

export function AuthGuard({ children }: { children: React.ReactNode }) {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

    useEffect(() => {
        if (!authClient.isAuthenticated()) {
            navigate("/");
        } else {
            setIsAuthorized(true);
        }
    }, [navigate]);

    if (isAuthorized === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#0f172a] text-white">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-400"></div>
            </div>
        );
    }

    return <>{children}</>;
}
